<template>
    <div class="survey-datepicker-container">
        <md-datepicker v-model="model" md-immediately :md-disabled-dates="disabled"/>
    </div>
</template>

<script>
export default {
  name: 'SurveyDatepicker',
  data() {
    return {
      model: this.field.value,
      currentDay: new Date().getDate(),
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      disabled: (date) => {
        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();
        if (year === this.currentYear && month === this.currentMonth) {
          return day > this.currentDay;
        }
        return (year > this.currentYear || month > this.currentMonth);
      },
    };
  },
  methods: {
    onModelChange() {
      this.$emit('modelChange', {
        newVal: this.model,
        oldVal: this.field.value,
        fieldId: this.field.id,
      });
      this.field.value = this.model;
      this.$emit('nodeChange', this.field);
    },
  },
  props: ['field'],
  computed: {
    getModel() {
      return this.model;
    },
  },
  watch: {
    getModel() {
      this.onModelChange();
    },
  },
  updated() {
    const domObj = this.$el.getElementsByClassName('md-clear');

    if (domObj[0].onclick) return;

    domObj[0].onclick = () => {
      this.model = undefined;
    };
  },
};
</script>

<style src="./SurveyDatepicker.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyDatepicker/SurveyDatepicker.vue